import { IconName } from '@boltenergy-be/design-system'

export const SOCIALS = new Map<string, { url: string; icon: IconName; title: string }>([
  [
    'facebook',
    {
      url: 'https://www.facebook.com/boltenergie',
      icon: 'facebook',
      title: 'Facebook'
    }
  ],
  [
    'instagram',
    {
      url: 'https://www.instagram.com/boltenergie',
      icon: 'instagram',
      title: 'Instagram'
    }
  ],
  [
    'linkedin',
    {
      url: 'https://www.linkedin.com/company/bolt-energie',
      icon: 'linkedinSquare',
      title: 'LinkedIn'
    }
  ],
  [
    'youtube',
    {
      url: 'https://www.youtube.com/@boltenergie',
      icon: 'youTube',
      title: 'YouTube'
    }
  ]
])
